export const scPlayer = function (el) {
    $("a.sc-player, div.sc-player").scPlayer();
};
